module.exports = __webpack_public_path__ + "static/media/MyPic.294bf4ba.jpg";